import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { useStatusBarControl } from '~/hooks/useStatusBarControl';
import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import { userStore } from '~/stores';

import ContentBottomSheet from '../../components/ContentBottomSheet/ContentBottomSheet';
import ProgressIndicator from '../../components/ProgressIndicator/ProgressIndicator';
import { useOnboardingHandlers } from '../../hooks/useOnboardingHandlers';
import { useStepData } from '../../hooks/useStepData';
import styles from './DefaultOnboarding.module.scss';

const DefaultOnboardingComponent = () => {
  const {
    handleChangeScreenIndex,
    handleTimerAlive,
    currentStepData,
    currentStep,
    additionalData,
    stepsNumber,
  } = useStepData();

  const {
    isLatestStep,
    handleLaterPress,
    handleNextPress,
    handlePrevPress,
    handleSubmitForm,
  } = useOnboardingHandlers({
    currentStep,
    stepsNumber,
    handleChangeScreenIndex,
    handleTimerAlive,
  });

  useStatusBarControl({
    initialColor: 'dark-content',
  });

  useEffect(() => {
    const dialogPayload = {
      type: 'no_store',
      postcode: userStore.deliveryAddress?.zip || '',
      lat: userStore.deliveryAddress?.coordinates.lat || '',
      lon: userStore.deliveryAddress?.coordinates.lng || '',
    };
    analyticsService.track(
      AnalyticsEvent.ONBOARDING_SUBSCRIBE_DIALOG_SHOWN,
      dialogPayload,
    );
    analyticsService.track(
      AnalyticsEvent.ONBOARDING_SUBSCRIBE_DIALOG_SHOWN_BI,
      dialogPayload,
    );
  }, []);

  return (
    <div
      className={styles.onboarding}
      style={{
        background: additionalData?.backgroundColor,
      }}
      data-company={company.name}
    >
      <button
        type="button"
        onClick={handleLaterPress}
        className={styles.closeButton}
      >
        <Icon className={styles.closeIcon} type="close" />
      </button>

      <div className={styles.progressIndicatorTop}>
        <ProgressIndicator
          stepsNumber={stepsNumber}
          activeStep={currentStep}
          noPadding={true}
        />
      </div>

      <div className={styles.imageContainer}>
        <div
          className={styles.image}
          style={{
            backgroundImage: `url('${currentStepData?.img}')`,
            backgroundPosition: currentStepData?.position || 'bottom',
          }}
        />
      </div>

      <ContentBottomSheet
        isVisibleInputs={isLatestStep}
        isLatestStep={isLatestStep}
        isVisibleInputLabels={additionalData?.isVisibleInputLabels}
        skipButtonText={additionalData?.skipButtonText}
        emailPlaceholder={additionalData?.inputEmailPlaceholder}
        firstNamePlaceholder={additionalData?.inputFirstNamePlaceholder}
        currentPage={currentStep}
        showBackButton={true}
        onNextPress={handleNextPress}
        onSubmitForm={handleSubmitForm}
        onLaterPress={handleLaterPress}
        onPrevPress={handlePrevPress}
        buttonsHeader={false}
        title={currentStepData?.textTitle || ''}
        description={currentStepData?.textDescription || ''}
      />
    </div>
  );
};

export const DefaultOnboarding = observer(DefaultOnboardingComponent);
